module.exports = __webpack_public_path__ + "img/er.3d321804.svg";